import { Container, Paper } from '@mui/material';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLoadShipmentCallback } from '../../states/shipment';
import ShipmentProfile from '../ShipmentProfile';

export default function ShipmentDetailContainer() {
  const params = useParams();
  const loadShipment = useLoadShipmentCallback();

  useEffect(() => {
    loadShipment(params.id);
  }, [loadShipment, params.id]);

  return (
    <Container maxWidth="xl" style={{ height: 'calc(100% - 65px)', paddingTop: '10px' }}>
      <Paper elevation={2}>
        <Container maxWidth="xl" style={{ padding: '15px' }}>
          <ShipmentProfile />
        </Container>
      </Paper>
    </Container>
  );
}
